'use client';

import { CSSProperties, FC } from 'react';
import { useTranslation } from '@/providers/app-provider/app-provider';

export interface RecipeIngredientsProps {
  ingredients: string[];
  ingredientsColor?: string;
  paddingStyle?: CSSProperties;
}

const RecipeIngredients: FC<RecipeIngredientsProps> = ({
  ingredients,
  ingredientsColor,
  paddingStyle,
}) => {
  const { t } = useTranslation();

  return (
    <div className="container mx-auto" style={paddingStyle}>
      {ingredients.length > 0 && (
        <>
          <h2 className="mb-3 text-lg font-semibold @md:text-xl">{t?.common.ingredients}</h2>
          <ul className="grid list-disc grid-cols-2 gap-x-6 gap-y-1 pl-5">
            {ingredients.map((ingredient, index) => (
              <li
                key={index}
                className="text-sm @md:text-base"
                style={ingredientsColor ? { color: ingredientsColor } : undefined}
              >
                {ingredient}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default RecipeIngredients;
